import { EventBus } from '../../utils'

export default EventBus()
